import React from 'react'
import { Modal } from 'antd'
import styles from './PaySuccessModal.module.less'
import { commonUtils } from '@/helpers/commonUtils'
import { CloseOutlined } from '@ant-design/icons'

export interface PaySuccessModalProps {
  visible: boolean
  onClose: () => void
  goodsName: string
  onDownload: () => void
}

const PaySuccessModal: React.FC<PaySuccessModalProps> = ({
  visible,
  onClose,
  goodsName,
  onDownload,
}) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={true}
      closeIcon={<CloseOutlined />}
      onCancel={onClose}
      width={590}
      centered
      title={null}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          padding: '40px 32px 40px',
          overflow: 'hidden',
          borderRadius: 18,
        },
      }}
      className={styles.paySuccessModal}
    >
      <div className={styles.content}>
        <div className={styles.crown}>
          <img src={commonUtils.getStaticFile('pc/pay/icon__crown.png')} alt='crown' />
        </div>
        <h2 className={styles.title}>开通成功</h2>
        <p className={styles.description} style={{ marginBottom: 0 }}>
          <img src={commonUtils.getStaticFile('pc/pay/icon__lihua.png')} alt='success' />
          恭喜你成功开通「{goodsName}」
        </p>
        <p className={styles.description}>快去下载使用课件吧</p>

        <div className={styles.qrCodeSection}>
          <div className={styles.qrCode}>
            <img
              src={commonUtils.getStaticFile('images/customer_qr/pay_success.png')}
              alt='QR Code'
            />
          </div>
          <div className={styles.right}>
            <p className={styles.qrCodeText}>
              <img src={commonUtils.getStaticFile('pc/pay/icon__niuma.png')} alt='客服' />
              添加专属客服，有任何问题可联系我们
            </p>
            <p className={styles.qrCodeHint}>(微信扫码即可添加)</p>
            <button className={styles.downloadButton} onClick={onDownload}>
              下载课件及教案
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PaySuccessModal
